const ocap = {
  state: () => ({
    /** OCAP關卡設定列表 */
    stageSettingList: [],

    /** OCAP關卡設定新增對話框是否顯示 */
    stageSettingFormVisible: false,

    /** OCAP流程設定新增對話框是否顯示 */
    flowSettingFormVisible: false,

    /** OCAP簽核查詢處理對話框是否顯示 */
    signatureQueryHandleVisible: false,

    /** OCAP簽核查詢紀錄列表 */
    ocapSignRecordList: [],
  }),

  mutations: {
    /** OCAP關卡設定列表 設值 */
    setStageSettingList(state, value) {
      state.stageSettingList = value;
    },

    /** OCAP關卡設定新增對話框是否顯示 設值 */
    setStageSettingFormVisible(state, value) {
      state.stageSettingFormVisible = value;
    },

    /** OCAP流程設定新增對話框是否顯示 設值 */
    setFlowSettingFormVisible(state, value) {
      state.flowSettingFormVisible = value;
    },

    /** OCAP簽核查詢處理對話框是否顯示 設值 */
    setSignatureQueryHandleVisible(state, value) {
      state.signatureQueryHandleVisible = value;
    },

    /** OCAP簽核查詢紀錄列表 設值 */
    setOcapSignRecordList(state, value) {
      state.ocapSignRecordList = value;
    },
  },
};

export default ocap;
